// extracted by mini-css-extract-plugin
export default {"modalContainer":"Vw","fadeRight":"Ww","fadeUp":"Xw","topShelf":"Yw","newFlavorBadge":"Zw","transparentText":"ax","cancelButton":"bx","invisibleLink":"cx","closeIcon":"ex","linkContainer":"fx","hed":"gx","image":"hx"};
    if(module.hot) {
      // 1715276855842
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  